import React from 'react';
import { Handle, Position } from '@xyflow/react';
import { NODE_HANDLE_IDS } from '@containers/flow/nodes';
import { useColorTheme } from '@hooks';

const DEFAULT_HANDLE_STYLE = {
  top: '15px',
  left: '6px',
};
export default React.memo(({ data, isConnectable }) => {
  const colorTheme = useColorTheme();
  return (
    <Handle
      type="target"
      id={NODE_HANDLE_IDS.query}
      position={Position.Left}
      style={{ ...DEFAULT_HANDLE_STYLE, background: colorTheme.text }}
      isConnectable={isConnectable}
    />
  );
});
